export default "__VITE_ASSET__DqKIaecO__"